import { render, staticRenderFns } from "./GridButtom.vue?vue&type=template&id=b0be75c8&"
import script from "./GridButtom.vue?vue&type=script&lang=js&"
export * from "./GridButtom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports